import { useCallback } from "react"
import { useGetOrganizationRefs } from "@tracabois/connect"
import { RealizationAssignActorCommand, RealizationId } from "../../../model/realizationModel"
import { useFormComposable, useFormFieldComposable } from "@komune-io/g2-composable"
import { FormComposable } from "@tracabois/components"

export interface RealizationActorAssignFormProps {
  onSubmit?: (item: RealizationAssignActorCommand) => Promise<boolean> | boolean
  onCancel?: () => void
  realizationId: RealizationId
}

export const RealizationActorAssignForm = (props: RealizationActorAssignFormProps) => {
  const { onSubmit, onCancel, realizationId } = props

  const organizationList = useGetOrganizationRefs({}).data || []

  const onSubmitMemoized = useCallback(
    async (values: RealizationAssignActorCommand) => {
      return !!onSubmit && onSubmit({ ...values, id: realizationId })
    },
    [onSubmit, realizationId]
  )

  const form = useFormComposable<RealizationAssignActorCommand>({
    onSubmit: onSubmitMemoized,
    formikConfig: {
      initialValues: {}
    },
    actions: {
      cancel: {
        label: "Annuler",
        onClick: onCancel,
      },
      validate: {
        label: "Sélectionner",
      }
    }
  })

  const formFields = useFormFieldComposable({
    fields: [
      {
        key: "organization.id",
        name: "organization.id",
        type: "autoComplete",
        validator: (_?: string, value?: Partial<RealizationAssignActorCommand>) => {
          const trimmed = (value?.organization?.id ?? "").trim()
          if (!trimmed) return "Vous devez renseigner une organisation" as string
          return undefined
        },
        params: {
          textFieldProps: {
            placeholder: "Sélectionner une organisation",
          },
          options: organizationList.map(item => ({
            key: item.id,
            label: item.name
          })) || []
        }
      },
    ]
  }, [organizationList])

  return (
    <FormComposable
      fields={formFields.fields}
      formState={form}
      actions={form.actions}
      actionsProps={{
        direction: "row",
        justifyContent: "flex-end",
      }}
    />
  )
}
